<div class="db-platform-account-upgraded">
   <img class="mb10"  src="assets/images/icons/account-upgraded-diamond.svg" alt="diamond" *ngIf="!!newPlans" />
    <h2 class="mb5" [ngClass]="{'platform': newPlans}" [innerHTML]="(fromBooster ? 'text_successfullyUpgradedFromBooster' : 'text_successfullyUpgradedFromAi') | dbText : {subscription: subscription?.plan?.title + (subscription?.category === UserSubscriptionCategory.PROFESSIONAl ? ' Professional' : '')}"></h2>
    <p class="mb30" *ngIf="!newPlans && !subscription?.boosterProClient">{{(fromBooster ? 'text_upgradedFromBoosterPlanInfo' : 'text_upgradedFromBoosterPlanInfo') | dbText : {count: subscription?.plan?.services?.hosting?.domain_count?.parameter_value, plural: (subscription?.plan?.services?.hosting?.domain_count?.parameter_value > 1 ? 's' : '')} }}</p>
    <p class="mb30" *ngIf="!newPlans && subscription?.boosterProClient">{{('text_upgradedFromBoosterTrialInfo') | dbText : {count: subscription?.plan?.totalDomainCount, plural: (subscription?.plan?.totalDomainCount > 1 ? 's' : '')} }}</p>
    <p class="mb40" *ngIf="!!newPlans">{{'text_upgradedSuccessFullyDesc' | dbText }}</p>
    <ul class="db-platform-account-upgraded__points {{!!subPoints ? 'mb8' : 'mb30'}}" *ngIf="!fromBooster">
      <li *ngFor="let point of points" [ngClass]="{'new-plans': !!newPlans}">
        <i class="db-icon db-icon-ds-checkmark-bg" *ngIf="!newPlans"></i>
        <img class="db-checkmark" src="assets/images/icons/checkmark-new.svg" *ngIf="!!newPlans" alt="checkmark" />
        <p [innerHTML]="point" [ngClass]="{'new-plans': !!newPlans}"></p>
      </li>
    </ul>
    <div *ngIf="!!subPoints" class="ml28 db-platform-account-upgraded__agency-subpoints">
      <ul class="db-platform-account-upgraded__sub-points">
        <li *ngFor="let subPoint of subPoints">
          <p [innerHTML]="subPoint"></p>
        </li>
      </ul>
    </div>
    <ul class="db-platform-account-upgraded__points mb30" *ngIf="!!secondPoints">
        <li *ngFor="let point of secondPoints" [ngClass]="{'new-plans': !!newPlans}">
            <img src="assets/images/icons/checkmark-white-blue.svg" class="mr2"/>
            <p [innerHTML]="point" [ngClass]="{'new-plans': !!newPlans}"></p>
        </li>
    </ul>

    <div *ngIf="!!secondSubPoints" class="ml28 db-platform-account-upgraded__agency-subpoints">
        <ul class="db-platform-account-upgraded__sub-points">
            <li *ngFor="let subPoint of secondSubPoints">
                <p [innerHTML]="subPoint"></p>
            </li>
        </ul>
    </div>

    <ul class="db-platform-account-upgraded__points mb30" *ngIf="fromBooster">
      <li *ngFor="let point of customPoints"  [ngClass]="{'new-plans': !!newPlans}">
        <i class="db-icon db-icon-ds-checkmark-bg" *ngIf="!newPlans"></i>
        <img src="assets/images/icons/checkmark-white-blue.svg" class="mr2" *ngIf="!!newPlans"/>
        <div>
          <b [innerHTML]="point.title" [ngClass]="{'new-plans': !!newPlans}"></b>
          <ul *ngIf="point.subPoints" class="db-platform-account-upgraded__sub-points">
            <li *ngFor="let subPoint of point.subPoints">
              <p [innerHTML]="subPoint"></p>
            </li>
          </ul>
        </div>
        <span *ngIf="point?.soon" class="soon">SOON</span>
      </li>
    </ul>
    <div class="db-platform-account-upgraded__buttons-wrap {{newPlans && 'platform'}} text-center mt30">
      <button class="ds-btn-black {{newPlans && 'ds-btn-max'}} rectangle" (click)="proceed()"><span>{{subscription?.apiResellerPro ? ('text_goToDashboard' | dbText): ('text_proceed' | dbText)}}</span></button>
    </div>
</div>
